import { Config } from '@flowwai-frontend/bps-officer-web/env-config'

export const isActivityLogsFeatureEnabled =
   Config.ENABLE_ACTIVITY_LOGS_FEATURE === 'true'

export const isAWExecutionLogsFeatureEnabled =
   Config.ENABLE_AW_EXECUTION_LOGS_FEATURE === 'true'

export const isRecordDistributionFeatureEnabled =
   Config.ENABLE_RECORD_DISTRIBUTION_FEATURE === 'true'

export const isDownloadsFeatureEnabled =
   Config.ENABLE_DOWNLOADS_FEATURE === 'true'

export const isIAMFeatureEnabled = Config.ENABLE_IAM_FEATURE === 'true'

export const isScheduledTriggerFeatureEnabled =
   Config.ENABLE_SCHEDULED_TRIGGER_FEATURE === 'true'

export const isWhatsappIntegrationsFeatureEnabled =
   Config.ENABLE_WHATSAPP_INTEGRATIONS === 'true'

export const isCloneGraphEnabled = Config.ENABLE_CLONE_GRAPH === 'true'

export const isMergeRecordsEnabled = Config.ENABLE_MERGE_RECORDS === 'true'

export const isNotificationsWebEnabled: boolean =
   Config.ENABLE_NOTIFICATIONS === 'true'

export const enableScheduledAWLogs = Config.ENABLE_SCHEDULED_AW_LOGS === 'true'

export const isGoogleCalendarIntegrationEnabled =
   Config.ENABLE_GOOGLE_CALENDAR_INTEGRATION === 'true'

export const isFileUploaderFieldEnabled =
   Config.ENABLE_FILE_UPLOADER_FIELD === 'true'
export const isGeoLocationFieldEnabled =
   Config.ENABLE_GEO_LOCATION_FIELD === 'true'

export const isAnalyticsCoPilotWebEnabled: boolean =
   Config.ENABLE_ANALYTICS_CO_PILOT === 'true'

export const isAISupportWebEnabled: boolean =
   Config.ENABLE_AI_SUPPORT === 'true'

export const isActivityTemplatesWebEnabled: boolean =
   Config.ENABLE_ACTIVITY_TEMPLATE_WEB === 'true'

export const isRecordCreationConfigSetupEnabled =
   Config.ENABLE_RECORD_CREATION_CONFIG_SETUP_WEB === 'true'
export const enableSignatureFieldsInDocuments =
   Config.ENABLE_SIGNATURE_FIELDS_IN_DOCUMENTS === 'true'

export const isDocumentTemplateQrSupportEnabled =
   Config.ENABLE_DOCUMENT_TEMPLATE_QR_CODE === 'true'

export const isConditionalOptionsFeatureEnabled =
   Config.ENABLE_CONDITIONAL_OPTIONS_FEATURE === 'true'

//TODO: update feature toggle
export const isDataUploadWithCsvFilesFeatureEnabled = true

export const isEmbeddedDataCoPilotEnabled =
   Config.ENABLE_EMBEDDED_DATA_CO_PILOT === 'true'

export const isAssigneeGroupsFeatureEnabled =
   Config.ENABLE_ASSIGNEE_GROUPS === 'true'

export const isTemplateConfigurationEnabled =
   isMergeRecordsEnabled || isAssigneeGroupsFeatureEnabled

export const isTemplatesConfigInPipelineCreationEnabled =
   Config.ENABLE_TEMPLATE_CONFIG_IN_CREATE_PIPELINE === 'true'

export const isEmbeddedAIChatSupportWebFeatureEnabled =
   Config.ENABLE_EMBEDDED_AI_CHAT_SUPPORT_WEB === 'true'

export const isEnableOpenSearchForGlobalSearch =
   Config.ENABLE_OPEN_SEARCH_FOR_GLOBAL_SEARCH === 'true'

export const isGisIntegrationEnabled = Config.ENABLE_GIS_INTEGRATION === 'true'

export const isApplicationDetailsV2RouteEnabled =
   Config.DETAILED_VIEW_UI_VERSION === 'V2'

export const isGISTabEnabled = Config.ENABLE_GIS_TAB === 'true'

export const shouldPrefillFieldsBasedOnLocation =
   Config.ENABLE_AUTOFILL_FIELDS_FROM_LOCATION_DATA === 'true'

export const isPMUPortalEnabled = Config.ENABLE_PMU_PORTAL === 'true'

export const isSearchAndMonitoringEnabled =
   Config.ENABLE_SEARCH_AND_MONITORING === 'true'

export const isQuickReviewGoogleMapsButtonEnabled =
   Config.ENABLE_QUICK_REVIEW_GOOGLE_MAPS === 'true'

export const isTaskDiscardedViewEnabled =
   Config.ENABLE_TASK_DISCARDED_VIEW === 'true'

export const enableLegacyApplications =
   Config.ENABLE_LEGACY_APPLICATIONS === 'true'

export const isAssignFriendEnabled = Config.ENABLE_ASSIGN_FRIEND === 'true'
